import {
  EhsFormioCheckbox,
  EhsFormioCheckboxGroup,
  EhsFormioCheckboxGroupType,
  EhsFormioCheckboxType,
  EhsFormioComponents,
  EhsFormioDataGrid,
  EhsFormioDataGridType,
  EhsFormioDateTimeInput,
  EhsFormioDateTimePicker,
  EhsFormioInfoModal,
  EhsFormioInfoModalType,
  EhsFormioNumberInput,
  EhsFormioNumberInputType,
  EhsFormioOpenChoiceCheckboxGroup,
  EhsFormioOpenChoiceCheckboxGroupType,
  EhsFormioOpenChoiceRadioButtons,
  EhsFormioOpenChoiceRadioType,
  EhsFormioQuantity,
  EhsFormioQuantityType,
  EhsFormioRadiobox,
  EhsFormioRadioType,
  EhsFormioSelectbox,
  EhsFormioSelectType,
  EhsFormioSVSSelect,
  EhsFormioSVSSelectType,
  EhsFormioTextInput,
  EhsFormioTextInputType,
  EhsFormioTimeInput,
  EhsFormioTimePicker,
  EhsFormioTimePickerType,
  FormioDateTimeInputType,
  FormioDateTimePickerType,
  FormioTimeInputType
} from './ehs';

EhsFormioComponents.addComponent(
  FormioDateTimeInputType,
  EhsFormioDateTimeInput
);
EhsFormioComponents.addComponent(FormioTimeInputType, EhsFormioTimeInput);
EhsFormioComponents.addComponent(EhsFormioInfoModalType, EhsFormioInfoModal);
EhsFormioComponents.addComponent(EhsFormioSVSSelectType, EhsFormioSVSSelect);
EhsFormioComponents.addComponent(EhsFormioCheckboxType, EhsFormioCheckbox);
EhsFormioComponents.addComponent(EhsFormioRadioType, EhsFormioRadiobox);
EhsFormioComponents.addComponent(
  EhsFormioOpenChoiceRadioType,
  EhsFormioOpenChoiceRadioButtons
);
EhsFormioComponents.addComponent(EhsFormioTextInputType, EhsFormioTextInput);
EhsFormioComponents.addComponent(
  EhsFormioNumberInputType,
  EhsFormioNumberInput
);
EhsFormioComponents.addComponent(EhsFormioSelectType, EhsFormioSelectbox);
EhsFormioComponents.addComponent(
  FormioDateTimePickerType,
  EhsFormioDateTimePicker
);

EhsFormioComponents.addComponent(EhsFormioTimePickerType, EhsFormioTimePicker);
EhsFormioComponents.addComponent(
  EhsFormioCheckboxGroupType,
  EhsFormioCheckboxGroup
);

EhsFormioComponents.addComponent(
  EhsFormioOpenChoiceCheckboxGroupType,
  EhsFormioOpenChoiceCheckboxGroup
);

EhsFormioComponents.addComponent(EhsFormioQuantityType, EhsFormioQuantity);

EhsFormioComponents.addComponent(EhsFormioDataGridType, EhsFormioDataGrid);

export * from './ehs/';
export * from './FormioAccessibility';
export * from './FormioContainer';
export * from './questionnaire/QuestionnaireContainer';
